export enum EUserOrderBy {
  name = 'name',
  email = 'email',
  role = 'role',
}
